import { trackError } from '@billy/track-error'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { TargetType } from '../../../enums/eInvoicing'
import { QueryKeys } from '../../../enums/queryKeys'
import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { PDP_NETWORK_TYPE } from '../constants'
import { getEInvoicingIntegrationPdpStatus } from '../query-api'

interface UseGetEInvoicingIntegrationPdpStatusOptions {
  enabled?: boolean
  onError?: () => void
}

export const useGetEInvoicingIntegrationPdp = ({
  enabled = true,
  onError,
}: UseGetEInvoicingIntegrationPdpStatusOptions = {}) => {
  const { organization } = useUserOrganization()

  const targetType = TargetType.BILLY
  const hasOrganizationReadScope = isAuthorized(Scope.OrganizationRead)

  const { data, isLoading } = useQuery(
    [QueryKeys.EInvoicingGetIntegrationPdp, PDP_NETWORK_TYPE, organization?.id],
    () => {
      if (!organization?.id) {
        trackError('Organization ID is required to get integration PDP status')
        return Promise.resolve({ data: null })
      }
      return getEInvoicingIntegrationPdpStatus({
        network: PDP_NETWORK_TYPE,
        targetId: organization.id,
        targetType,
      })
    },
    {
      enabled: enabled && !!organization?.id && hasOrganizationReadScope,
      onError,
    },
  )

  return {
    eInvoiceIntegration: data?.data,
    eInvoiceIntegrationPdpStatus: data?.data?.status,
    eInvoiceIntegrationPdpScope: data?.data?.scope,
    eInvoiceIntegrationPdpNetworkStatus: data?.data?.networkStatus,
    eInvoiceIntegrationPdpActivationDate: data?.data?.statusChangedAt,
    isProcessing: isLoading,
  }
}
